import { Component, OnDestroy, OnInit } from '@angular/core';
import { WebSocketSubject } from "rxjs/webSocket";
import { Subscription } from 'rxjs';
import { WebSocketService } from '../socket-service/web-socket.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-socket-notification',
  templateUrl: './socket-notification.component.html',
  styleUrls: ['./socket-notification.component.css']
})
export class SocketNotificationComponent implements OnInit, OnDestroy {
  private _isActive: boolean = false;
  private _isReconnecting: boolean = false;
  private _subscriptions: Subscription[] = [];
  private _subscription: Subscription;
  
  constructor(
    private _websocketService: WebSocketService,
    private _dataSer: DataService
  ) {
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'socketReconnect') {
        this._reconnect();
      }
    });
  }

  ngOnInit(): void {
    const socketDisconnected = sessionStorage.getItem('socketDisconnected') ?
      JSON.parse(sessionStorage.getItem('socketDisconnected')) : false;
    if (!socketDisconnected) {
      this._websocketService.getPubsubToken();
      this._subscriptions.push(this._websocketService.isActive$.subscribe((isActive: boolean) => {
        this._isActive = isActive;
        this._dataSer.broadcast('isActiveSocket', this._isActive);
      }));
      this._subscriptions.push(this._websocketService.isReconnecting$.subscribe((isReconnecting: boolean) => {
        this._isReconnecting = isReconnecting;
        this._dataSer.broadcast('isReconnectingSocket', this._isReconnecting);
      }));
    }
  }

  ngOnDestroy(): void {
    if (this._subscriptions.length > 0) {
      this._subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
    if (this._subscription)
    this._subscription?.unsubscribe();

  }

  // sendMessage() {
  //   this._websocketService.sendMessage({ message: 'some message' });
  // }

  private _closeWebSocket() {
    this._websocketService.close();
  }

  private _reconnect() {
    this._websocketService.reconnect();
  }

  private _logOutAndClose() {
    this._websocketService.logoutAndClose();
  }

}
